<template>

    <div class="links">

        <p class="title">Saisissez ce code lors de la création de votre compte</p>

        <button class="copy" @click="copyCode">
            <span class="partner">{{ partnerName }}</span>
            <span v-if="!codeCopied">{{ $t('we_forest_click_to_copy') }}</span>
            <span v-else class="code-copied">{{ $t('we_forest_code_copied') }}</span>
        </button>

        <p class="text">{{ $t('partner_page_test_cleanfox_simplified') }}</p>

        <div class="natives" v-show="!isDesktop">
            <button class="cta-ios" @click="easyIos">{{ $t('partner_page_for_IOS') }}</button>
            <button class="cta-android" @click="easyAndroid">{{ $t('partner_page_for_android') }}</button>
        </div>

        <div class="qrs" v-show="isDesktop">
            <div class="platform platform-ios">
                <p>{{ $t('partner_page_for_IOS') }}</p>
                <div class="blue">
                    <img src="/img/partner/qr-code-app-clip-1.svg">
                </div>
            </div>
            <div class="platform platform-android">
                <p>{{ $t('partner_page_for_android') }}</p>
                <div class="blue blue-android">
                    <q-r-code-instant-app :big="true"></q-r-code-instant-app>
                </div>
            </div>
        </div>

        <div class="divided">
            <div class="line"></div>
            <span class="or">{{ $t('generic_or') }}</span>
            <div class="line"></div>
        </div>

        <p class="text">{{ $t('generic_download_app') }}</p>

        <div class="tags">
            <img src="/img/partner/download-on-the-app-store-badge-us-uk-rgb-blk-092917.svg" class="ios"
                 @click="bandIos">
            <img src="/img/partner/google-play-badge-2@3x.webp" class="android" @click="bandAndroid">
        </div>

        <div class="divided" v-show="isDesktop">
            <div class="line"></div>
            <span class="or">{{ $t('generic_or') }}</span>
            <div class="line"></div>
        </div>

        <div class="web" v-show="isDesktop">
            <p>{{ $t('partner_page_continue_web') }}</p>
            <button @click="goLogin">{{ $t('create_my_account') }}</button>
        </div>
    </div>

</template>

<script>
import Vuex from 'vuex'

import Storage from '../../helpers/storage'
import UserAgent from '../../modules/userAgent'
import Tag from '../../modules/tag'

import QRCodeInstantApp from '../../components/landing/QRCodeInstantApp'

export default {

    name: 'partner-links',
    
    components: {QRCodeInstantApp},

    computed: {
        ...Vuex.mapGetters(['actualPartner']),

        partnerName() {
            return this.actualPartner.code
        }

    },

    data() {
        return {
            showTemporarily: false,
            codeCopied: false,
        }
    },

    methods: {
        copyCode() {

            Storage.setItem('partnerCode', this.actualPartner.code)

            // createTextArea
            const textArea = document.createElement('textArea')
            textArea.value = this.actualPartner.code
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            // selectText
            if (UserAgent.is.ios()) {
                const range = document.createRange()
                range.selectNodeContents(textArea)
                const selection = window.getSelection()
                selection.removeAllRanges()
                selection.addRange(range)
                textArea.setSelectionRange(0, 999999)
            } else {
                textArea.select()
            }

            // copyToClipboard
            document.execCommand('copy')
            document.body.removeChild(textArea)

            this.codeCopied = true
        },

        easyIos() {
            Tag.clickAll(this, 'use_appclip')
            window.open('https://cleanfox.io/', '_blank', 'rel="noopener,noreferrer,nofollow"')
        },
        easyAndroid() {
            Tag.clickAll(this, 'use_instant_app')
            window.open('https://play.google.com/store/apps/details?id=io.cleanfox.android&launch=true', '_blank', 'rel="noopener,noreferrer,nofollow"')
        },
        bandIos() {
            Tag.clickAll(this, 'download_appstore')
            this.downloadAdjust()
        },
        bandAndroid() {
            Tag.clickAll(this, 'download_playstore')
            this.downloadAdjust()
        },
        downloadAdjust() {
            window.open('https://app.adjust.com/2p936hy', '_blank', 'rel="noopener,noreferrer,nofollow"')
        },
        goLogin() {
            this.$router.push({path: '/'})
        }
    }

}
</script>

<style lang="scss" scoped>

.links {
    width: 100%;
    margin-top: 20px;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $timberwolf;
    border-radius: 20px;
    font-family: proxima-nova;
    @media screen and (min-width: $above-tablet-length) {
        padding: 32px 48px;
    }

    .title {
        font-size: 14px;
        font-weight: 500;
        color: $charcoal;
    }

    .copy {
        width: 100%;
        margin-top: 8px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        background-color: $white;
        border-radius: 40px;
        font-size: 12px;
        font-weight: 500;
        color: $neutralsMoon;
        text-align: center;
        align-items: center;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 16px;
        }

        .partner {
            font-size: 18px;
            font-weight: 600;
            letter-spacing: 2.16px;
            color: $aquamarine;
            margin-bottom: 2px;
        }
    }

    .code-copied {
        color: $lime;
    }

    .text {
        margin-top: 40px;
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        color: $charcoal;
    }

    .natives {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top: 24px;

        > button {
            font-family: 'proxima-nova';
            font-size: 17px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.41;
            letter-spacing: normal;
            text-align: center;
            color: $white;
            padding: 16px;
            border-radius: 40px;
            flex: 1;
        }

        .cta-ios {
            background-color: $aquamarine;
            margin-right: 4px;
        }

        .cta-android {
            margin-left: 4px;
            background-color: $midnight;
        }
    }

    .divided {
        margin-top: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;

        .line {
            width: 100%;
            height: 2px;
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D7D9DFFF' stroke-width='7' stroke-dasharray='7%2c 7' stroke-dashoffset='4' stroke-linecap='butt'/%3e%3c/svg%3e");
            @media screen and (min-width: $above-tablet-length) {
                background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D7D9DFFF' stroke-width='10' stroke-dasharray='10%2c 10' stroke-dashoffset='3' stroke-linecap='butt'/%3e%3c/svg%3e");
            }
        }

        .or {
            font-size: 18px;
            font-weight: 600;
            line-height: 1.33;
            color: $aquamarine;
            margin: 0 16px;
            @media screen and (min-width: $above-tablet-length) {
                font-size: 22px;
                font-weight: 600;
                line-height: 1.09;
            }
        }
    }

    .tags {
        margin-top: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: center;

        > img {
            width: 50%;
            margin: 0 12px;
        }

        .ios {
            cursor: pointer;
            margin-right: 8px;
            max-width: 144px;
        }

        .android {
            cursor: pointer;
            margin-left: 8px;
            max-width: 162px;
        }
    }

    .qrs {
        margin-top: 32px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .platform {
            text-align: center;
            flex: 1;
            font-size: 16px;
            font-weight: 500;
            color: $neutralsMoon;
            display: flex;
            flex-direction: column;
        }

        .platform-ios {
            margin-right: 16px;
        }

        .platform-android {
            margin-left: 16px;
        }

        .blue {
            margin-top: 16px;
            background-color: $aquamarine;
            border-radius: 40px;
            overflow: hidden;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .blue-android {
            padding: 0 24px;
        }
    }

    .web {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.2;
        color: $charcoal;

        > button {
            margin-top: 32px;
            padding: 16px 40px;
            border-radius: 32px;
            background-color: $aquamarine;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            font-weight: 500;
            line-height: 1.41;
            color: $white;
        }
    }
}

</style>
